import Button from 'core/components/buttons/Button'
import useNavigation from 'core/hooks/navigation/useNavigation'
import StartLandingBg from 'assets/images/motus-start-page-bg.png'
import Icon from 'core/components/icons/Icon'
import FeatureIcon from 'core/components/icons/FeatureIcon'
import {
  LINK_EVERLANCE_PRIVACY,
  LINK_EVERLANCE_TERMS_OF_SERVICE
} from 'constants/Links'
import { LoginUrl, SSOUrl } from 'constants/RouteUrls'
import PurpleAccessModal from 'pages/auth/purple/PurpleAccessModal'
import { useState } from 'react'
import useUrlParams from 'core/hooks/navigation/useUrlParams'

const valueProps = [
  {
    title: 'Get started for free',
    description: 'Easy set up with no credit card required'
  },
  {
    title: 'Automatic trip & expense tracking',
    description:
      'GPS satellites ensure accurate trip tracking even without cell phone service.  Integrate your bank or credit card for easy expense management.'
  },
  {
    title: 'IRS compliant reports',
    description: 'Export a complete record of your trips and expenses.'
  }
]

const PurpleStartPage = () => {
  const { push } = useNavigation()
  const [urlParams, setUrlParams] = useUrlParams()
  const futureAccessDate = urlParams.get('futureAccessDate')
  const [showAccessModal, setShowAccessModal] = useState(!!futureAccessDate)
  return (
    <div className="h-screen flex justify-around items-center relative">
      <PurpleAccessModal
        show={showAccessModal}
        onClose={() => {
          setShowAccessModal(false)
          urlParams.delete('futureAccessDate')
          setUrlParams(urlParams)
        }}
        accessDate={futureAccessDate}
      />
      <img
        src={StartLandingBg}
        alt="road background with place markers"
        className="absolute z-0 w-screen h-screen object-cover"
      />
      <div className="flex-col items-center hidden md:flex p-4 basis-[500px] z-10">
        <div>
          {valueProps.map((valueProp) => (
            <div className="flex flex-row mb-5" key={valueProp.title}>
              <div className="mr-4 mt-1">
                <Icon
                  className="text-white p-1 bg-primary rounded-full"
                  size={14}
                  name="check"
                />
              </div>

              <div className="text-xl">
                <strong>{valueProp.title}</strong>
                <p className="text-dark-4">{valueProp.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="card bg-white md:px-20 md:max-w-xl basis-[500px] z-10">
        <div className="flex justify-center flex-col items-center">
          <FeatureIcon name="motus-logo" width={100} />
          <h3 className="text-4xl text-center mb-10 mt-6 text-primary font-bold">
            Effortless mileage tracking
          </h3>
        </div>

        <div className="flex flex-col justify-center h-full gap-5 ">
          <Button
            type="submit"
            variant="outline"
            className="w-full py-3!"
            onClick={() => {
              push(LoginUrl)
            }}
          >
            Continue with Username / Email
          </Button>
          <Button
            type="submit"
            variant="outline"
            className="w-full py-3!"
            onClick={() => {
              push(SSOUrl)
            }}
          >
            Sign in with SSO
          </Button>
          <div className="mt-3">
            <p className="text-sm text-center">
              By signing up, you agree to our{' '}
              <a
                href={LINK_EVERLANCE_TERMS_OF_SERVICE}
                target="_blank"
                rel="noreferrer"
                className="underline text-sm"
              >
                Terms and Conditions
              </a>{' '}
              and acknowledge that you have read our{' '}
              <a
                href={LINK_EVERLANCE_PRIVACY}
                target="_blank"
                rel="noreferrer"
                className="underline text-sm"
              >
                Privacy Policy
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PurpleStartPage
